import { chainConfig, ethereumFacts } from '@morpho-org/viem-dlc/chains'
import { defineChain as viemDefineChain } from 'viem'
import { unichain as viemUnichain } from 'viem/chains'

import type { AppChain } from './chain.types'

export const unichain = viemDefineChain({ ...viemUnichain, ...chainConfig }).extend({
  viemDlc: ethereumFacts,
  custom: {
    name: 'Unichain',
    shortName: 'Unichain',
    safeShortName: 'unichain',
    morphoChainSlug: 'unichain',
    defiLlamaSlug: 'unichain',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://uniscan.xyz', name: 'Uniscan' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x9a6061d51743B31D2c3Be75D83781Fa423f53F0E',
          startBlock: 9139027n
        },
        MorphoBlue: { address: '0x8f5ae9CddB9f68de460C77730b018Ae7E04a140A', startBlock: 9139027n },
        MetaMorphoV11Factory: {
          address: '0xe9EdE3929F43a7062a007C3e8652e4ACa610Bdc0',
          startBlock: 9316789n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0xC9b34c108014B44e5a189A830e7e04c56704a0c9',
          startBlock: 29092109n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0x117b92Ab1C025B175ED38a0CDe5A067a745224a0',
          startBlock: 29092109n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0x9a13bdA35F98811fbAcf097966b2C838f3F9c58C',
          startBlock: 34613548n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0xf1Ab9e885C0faa0cbCEd407498BBA895537aD754',
          startBlock: 29092109n
        },
        RegistryList: {
          address: '0xB9130D2A87d7c60ED7E7e4b25bdA6e3E6841becB',
          startBlock: 29092328n
        },
        BluePublicAllocator: {
          address: '0x2b7Bf2f2027bcfE3A1F6Bc93EA80220a883a6851',
          startBlock: 56168924n
        }
      }
    }
  }
}) satisfies AppChain<{ v1: true; v2: true }>
